<template>
  <el-scrollbar>
    <div style="display: flex; flex-direction: column; margin-bottom: 17px">
      <el-form :model="linkInfo" :rules="rules" ref="refForm" inline label-width="110px">
        <el-col :span="12">
          <el-form-item label="规则名称" prop="ruleName">
            <span v-if="optType === 'view'">{{ linkInfo.ruleName }}</span>
            <el-input
              v-else
              v-model="linkInfo.ruleName"
              clearable
              placeholder="请输入规则名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="规则优先级" prop="levelNum">
            <span v-if="optType === 'view'">{{ linkInfo.levelNum }}</span>
            <el-select
              v-else
              style="width: 100%"
              v-model="linkInfo.levelNum"
              placeholder="请选择规则优先级（1~100，数字越小优先级越高）"
            >
              <el-option
                v-for="item in priorityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="规则说明" prop="description" label-width="100px">
            <span v-if="optType === 'view'">{{ linkInfo.description }}</span>
            <el-input
              type="textarea"
              placeholder="请输入规则说明"
              v-model="linkInfo.description"
              maxlength="200"
              show-word-limit
              rows="5"
              resize="none"
            />
          </el-form-item>
        </el-col>
      </el-form>
      <div class="link-item">
        <div class="left-item">
          <div style="padding: 10px; color: white; font-size: 16px">
            请选择触发设备及事件
          </div>
          <div
            style="display: flex; margin-top: 10px; margin-bottom: 10px"
            v-show="isAdd"
          >
            <el-select v-model="equipmentValue" style="width: 200px; margin-left: 10px">
              <el-option
                v-for="item in equipmentType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-cascader
              :options="nameList"
              :show-all-levels="false"
              collapse-tags
              clearable
              v-model="selectedNameList"
              v-show="isAdd"
              style="width: 210px; margin-left: 10px; margin-right: 10px"
              :props="{ multiple: true, label: 'name', value: 'id' }"
            />
          </div>
          <div class="input_nav" v-show="isAdd">
            <el-input
              placeholder="请输入设备名称"
              v-model="searchKeyword"
              style="width: 340px; margin-left: 10px; margin-right: 10px"
            >
              <el-button slot="append" icon="el-icon-search" @click="getDeviceList" />
            </el-input>
          </div>
          <link-left-tree
            ref="leftTree"
            :device-name="deviceName"
            :device-type="equipmentValue"
            v-show="isAdd"
            @handleTreeSelect="handleTreeSelect"
          />
          <div
            style="display: flex; justify-content: space-between; margin: 10px"
            v-show="isAdd"
          >
            <div
              style="cursor: pointer; display: flex; align-items: center"
              @click="handleLeftDelete"
            >
              <span class="el-icon-delete" style="padding-left: 8px; font-size: 14px"
                >&nbsp;删除</span
              >
            </div>
            <!-- <div style="cursor: pointer; display: flex; align-items: center">
              <span class="soc iconPreview" style="font-size: 14px; color: #5d89e0"
                @click="handleOpenMap(false)">&nbsp;地图显示设备</span>
            </div> -->
          </div>
          <el-table
            :data="tableData"
            @selection-change="changeSelection"
            max-height="250"
          >
            <el-table-column type="selection" width="55" v-if="isAdd" />
            <el-table-column prop="name" label="设备名称" show-overflow-tooltip>
              <template slot-scope="scope">
                <div>
                  <i :class="['soc', hasClass(scope.row.deviceType)]"></i>
                  <span style="margin-left: 3px">{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="eventName" label="事件类型" show-overflow-tooltip />
          </el-table>
        </div>
        <div class="right-item">
          <div style="padding: 10px; color: white; font-size: 16px">设置联动动作</div>
          <div style="display: flex; margin: 10px 0 0 10px">
            <el-select v-model="equipmentTreeValue">
              <el-option
                v-for="item in equipmentTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <div class="input_nav">
              <el-input
                placeholder="请输入设备名称"
                v-model="searchTreeKeyword"
                style="width: 340px; margin-left: 10px; margin-right: 10px"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="getDeviceTreeList"
                />
              </el-input>
            </div>
          </div>
          <link-right-tree
            ref="rightTree"
            :device-name="deviceTreeName"
            :device-type="equipmentTreeValue"
            :tableData="tableData"
            :radius="activeNum"
            @handleUpdateTable="handleUpdateTable"
            :positions="positions"
          />
          <div style="display: flex; justify-content: space-between; margin: 10px">
            <div style="cursor: pointer; display: flex; align-items: center">
              <span
                class="el-icon-delete"
                @click="handleRightDelete"
                style="padding-left: 8px; font-size: 14px"
                >&nbsp;删除</span
              >
            </div>
            <!-- <div style="cursor: pointer; display: flex; align-items: center">
              <span class="soc iconPreview" style="font-size: 14px; color: #5d89e0"
                @click="handleOpenMap(true)">&nbsp;地图显示设备</span>
            </div> -->
          </div>
          <el-table
            :data="deviceData"
            @selection-change="changeSelections"
            max-height="250"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column type="index" label="序号" width="50" />
            <el-table-column prop="resName" label="设备名称">
              <template slot-scope="scope">
                <div>
                  <i :class="['soc', hasClass(scope.row.deviceType)]"></i>
                  <span style="margin-left: 3px">{{ scope.row.resName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="doAction" label="联动动作">
              <template slot-scope="scope">
                <div style="display: flex; justify-content: space-between">
                  <span>{{ hasActionName(scope.row.doAction) }}</span>
                  <span v-if="scope.row.doAction === 2"
                    >布控
                    <el-switch
                      v-model="scope.row.isMonit"
                      active-color="#407AEE"
                      inactive-color="#465275"
                      :active-value="0"
                      :inactive-value="1"
                    />
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="order" label="执行顺序">
              <template slot-scope="scope">
                <div class="order">
                  <i class="soc iconjiantou1" @click="handleSort(scope.row, 1)"></i>
                  <i
                    class="soc iconjiantou-copy-copy1"
                    @click="handleSort(scope.row, 2)"
                  ></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="map-floor-bar">
            <ul>
              <li class="map-prev" @click.stop="handlePrev">
                <i class="el-icon-arrow-up"></i>
              </li>
              <li
                :class="{ active: item.number === activeNum }"
                @click.stop="handleSearchDevice(item.value, item.number)"
                v-for="(item, index) in rangeData"
                :key="index"
              >
                <div class="left-arrow" v-if="item.number === activeNum"></div>
                <div class="right-arrow" v-if="item.number === activeNum"></div>
                {{ item.label }}
              </li>
              <li class="map-next" @click.stop="handleNext">
                <i class="el-icon-arrow-down"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
import LinkLeftTree from "@ISS/linkage/components/link-left-tree";
import LinkRightTree from "@ISS/linkage/components/link-right-tree";

export default {
  name: "linkageOptCom",
  components: { LinkRightTree, LinkLeftTree },
  props: {
    optType: {
      type: String,
      default: "",
    },
    nameList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    selectedNameList: function (newValue) {
      if (newValue.length > 0) {
        this.handleTreeSelect(this.leftSelectData);
      }
    },
  },
  data() {
    return {
      ruleId: "",
      isAdd: true,
      rangeData: [
        {
          label: "不限",
          number: "40",
          value: "40",
        },
        {
          label: "30m",
          number: "30",
          value: "30",
        },
        {
          label: "20m",
          number: "20",
          value: "20",
        },
        {
          label: "10m",
          number: "10",
          value: "10",
        },
      ],
      activeNum: "40",
      linkInfo: {
        ruleName: "",
        levelNum: "",
        description: "",
      },
      rules: {
        ruleName: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        levelNum: [{ required: true, message: "请选择规则优先级", trigger: "blur" }],
      },
      priorityList: [],
      equipmentType: [
        {
          value: "18",
          label: "摄像机",
        },
      ],
      searchKeyword: "",
      searchTreeKeyword: "",
      deviceName: "",
      deviceTreeName: "",
      equipmentTreeValue: "",
      equipmentTypes: [
        {
          value: "18",
          label: "摄像机",
        },
        {
          value: "22",
          label: "门禁",
        },
        {
          value: "25",
          label: "车辆道闸",
        },
      ],
      equipmentValue: "18",
      selectedNameList: [],
      leftSelectData: [],
      multipleSelection: [],
      multipleSelections: [],
      tableData: [],
      deviceData: [],
      positions: [],
    };
  },
  created() {
    for (let i = 1; i < 101; i++) {
      this.priorityList.push({
        label: i,
        value: i,
      });
    }
  },
  mounted() {
    this.isAdd = true;
  },
  methods: {
    handleEdit(info) {
      this.isAdd = false;
      this.ruleId = info.ruleId;
      this.linkInfo.description = info.description;
      this.linkInfo.levelNum = info.levelNum;
      this.linkInfo.ruleName = info.ruleName;
      this.deviceData = info.action;
      this.selectedNameList = info.eventType.split(",");
      let positions = [];
      positions.push({
        lat: info.lat,
        lng: info.lng,
      });
      this.positions = JSON.parse(JSON.stringify(positions));
      this.tableData = [info];
    },
    /**
     * 顺序切换查询设备
     */
    handleSearchDevice(value, number) {
      console.log("##########", value);
      this.activeNum = number;
    },
    /**
     * 顺序切换查询设备
     */
    handleNext() {
      let num = 0;
      this.rangeData.forEach((item, index) => {
        if (item.number === this.activeNum) {
          num = index;
        }
      });
      if (num + 1 < this.rangeData.length) {
        this.handleSearchDevice(
          this.rangeData[num + 1].value,
          this.rangeData[num + 1].number
        );
      }
    },
    /**
     * 倒序切换查询设备
     */
    handlePrev() {
      let num = 0;
      this.rangeData.forEach((item, index) => {
        if (item.number === this.activeNum) {
          num = index;
        }
      });
      if (num - 1 >= 0) {
        this.handleSearchDevice(
          this.rangeData[num - 1].value,
          this.rangeData[num - 1].number
        );
      }
    },
    /**
     * 摄像机重新排序
     */
    handleSort(row, num) {
      let index = -1;
      for (let i = 0; i < this.deviceData.length; i++) {
        if (this.deviceData[i].code === row.code) {
          index = i;
        }
      }
      if (
        (index === 0 && num === 2) ||
        (index === this.deviceData.length - 1 && num === 1)
      ) {
        return;
      }
      let info = {};
      if (num === 1) {
        info = this.deviceData[index + 1];
        this.deviceData[index + 1] = this.deviceData[index];
        this.deviceData[index] = info;
      } else {
        info = this.deviceData[index - 1];
        this.deviceData[index - 1] = this.deviceData[index];
        this.deviceData[index] = info;
      }
      this.deviceData = JSON.parse(JSON.stringify(this.deviceData));
      console.log("index", index, this.deviceData.length);
    },
    hasActionName(val) {
      switch (val) {
        case 1:
          return "抓拍";
        case 2:
          return "人脸抓拍";
        case 3:
          return "录像";
        case 4:
          return "开门";
        case 5:
          return "关门";
        case 6:
          return "广播";
      }
    },
    handleRightDelete() {
      if (this.multipleSelections.length === 0) {
        return;
      }
      let arr = [];
      arr = this.deviceData.filter((item) => {
        return this.multipleSelections.join(",").indexOf(item.code) === -1;
      });
      this.deviceData = JSON.parse(JSON.stringify(arr));
    },
    handleUpdateTable(data, checkList, musicId) {
      let arr = [];
      this.deviceData.forEach((item) => {
        if (!arr.some((val) => val === item.resCode)) {
          arr.push(item.resCode);
        }
      });
      if (checkList.length > 0) {
        checkList.forEach((item) => {
          let par = JSON.parse(JSON.stringify(data));
          if (par.resType === "3001") {
            par.musicId = musicId;
          }
          par.doAction = item;
          par.isMonit = 1;
          par.code = par.resCode + par.doAction;
          if (this.deviceData.every((item) => item.code !== par.code)) {
            this.deviceData.push(par);
          }
        });
      }
    },
    changeSelections(vals) {
      console.info("this.multipleSelection", this.multipleSelection);
      this.multipleSelections = vals.map((item) => item.code);
    },
    changeSelection(vals) {
      console.info("this.multipleSelection", this.multipleSelection);
      this.multipleSelection = vals.map((item) => item.thirdDeviceId);
    },
    /**
     * 列表样式
     * @param type
     */
    hasClass(type) {
      switch (type) {
        case "18":
          return "iconGunMachine";
        case "1102":
          return "iconGunMachine";
        case "1103":
          return "iconBallMachine";
        case "1104":
          return "iconHalfMachine";
        case "1105":
          return "iconGunMachine";
      }
    },
    handleLeftDelete() {
      if (this.multipleSelection.length === 0) {
        return;
      }
      let arr = [];
      arr = this.tableData.filter((item) => {
        return this.multipleSelection.join(",").indexOf(item.thirdDeviceId) === -1;
      });
      this.tableData = JSON.parse(JSON.stringify(arr));
      let positions = [];
      this.tableData.forEach((item) => {
        positions.push({
          lat: item.latitude,
          lng: item.longitude,
        });
      });
      this.positions = positions;
      this.$refs.leftTree.$refs.searchTree.setCheckedKeys(
        this.tableData.map((item) => item.thirdDeviceId)
      );
    },
    /**
     * 左边树的选择数据
     */
    handleTreeSelect(val) {
      if (!this.isAdd) {
        return;
      }
      let eventType = [];
      let eventName = [];
      if (this.selectedNameList.length > 0) {
        this.selectedNameList.forEach((item) => {
          const firstIndex = this.nameList.findIndex((v) => v.id === item[0]);
          const secondIndex = this.nameList[firstIndex].children.findIndex(
            (v) => v.id === item[1]
          );
          const info = this.nameList[firstIndex].children[secondIndex];
          eventType.push(info.id);
          eventName.push(info.name);
        });
        this.tableData = val.map((item) => {
          item.eventName = eventName.join(",");
          item.eventType = eventType.join(",");
          return item;
        });
        let positions = [];
        this.tableData.forEach((item) => {
          positions.push({
            lat: item.latitude,
            lng: item.longitude,
          });
        });
        this.positions = positions;
      } else {
        this.leftSelectData = val;
      }
    },
    getDeviceTreeList() {
      this.deviceTreeName = this.searchTreeKeyword;
    },
    getDeviceList() {
      this.deviceName = this.searchKeyword;
    },
  },
};
</script>
<style>
.el-table__body-wrapper {
  height: 100% !important;
}
</style>

<style lang="scss" scoped>
.el-form-item {
  display: flex;
  width: 100%;
}

:deep .el-form-item__content {
  width: 100%;
}

//&:first-child .order .iconjiantou-copy-copy1 {
//  color: #586583;
//  cursor: not-allowed;
//}
//
//&:last-child .order .iconjiantou1 {
//  color: #586583;
//  cursor: not-allowed;
//}

.map-floor-bar {
  width: 30px;
  position: absolute;
  z-index: 1 !important;
  right: 30px !important;
  top: 90px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;

    li {
      height: 24px;
      background: rgba(72, 84, 121, 0.85);
      line-height: 24px;
      text-align: center;
      color: rgba(#fff, 0.5);
      cursor: pointer;
      position: relative;
      font-size: 12px;

      .left-arrow {
        width: 0;
        height: 0;
        border: 3px solid transparent;
        border-left-color: #407aee;
        position: absolute;
        content: "";
        top: 9px;
      }

      .right-arrow {
        width: 0;
        height: 0;
        border: 3px solid transparent;
        border-right-color: #407aee;
        position: absolute;
        content: "";
        top: 9px;
        right: 0;
      }

      &.active {
        color: #fff;
        border-left: #407aee solid 2px;
        border-right: #407aee solid 2px;
        background: rgba(63, 75, 113, 0.85);
      }

      &.map-prev,
      &.map-next {
        height: 20px;
        background: #62719c;
        line-height: 20px;
        color: #fff;
      }

      &.map-prev {
        margin-bottom: 3px;
      }

      &.last-out {
        height: 35px;
        line-height: 35px;
        background: #3e4766;
        color: #fff;
      }

      &.last {
        margin-top: 3px;
        height: 30px;
        line-height: 15px;
        color: #fff;
        display: flex;
        font-size: 12px;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
          margin: 0;
          padding: 0;
        }

        i {
          transform: rotate(270deg);
          -ms-transform: rotate(270deg);
          /* IE 9 */
          -moz-transform: rotate(270deg);
          /* Firefox */
          -webkit-transform: rotate(270deg);
          /* Safari 和 Chrome */
          -o-transform: rotate(270deg);
        }
      }
    }
  }
}

.soc {
  cursor: pointer;
}

.link-item {
  display: flex;
  //height: 900px;

  .left-item {
    width: 362px;
    display: flex;
    flex-direction: column;
    // border: 1px #394567 solid;
    border: 1px #c0c4cc solid;
  }

  .right-item {
    display: flex;
    flex: 1;
    margin-left: 40px;
    flex-direction: column;
    // border: 1px #394567 solid;
    border: 1px #c0c4cc solid;
    position: relative;
  }
}
</style>
